import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { InspectionCase } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-failed-inspection-notes',
  templateUrl: './failed-inspection-notes.component.html',
  styleUrls: ['./failed-inspection-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FailedInspectionNotesComponent implements OnInit {
  @Input() inspectionCases: InspectionCase[] = [];

  notesToDisplay: string[] = [];

  ngOnInit(): void {
    this.inspectionCases = this.inspectionCases ?? [];
    const notes: string[] = this.inspectionCases
      .filter((x) => !x.isPassed)
      .flatMap((x) => x.getNotes().filter((note) => note.addNotesToReport))
      .map((x) => x.notes);

    const set: Set<string> = new Set(notes);
    this.notesToDisplay = Array.from(set);
  }
}
